/**
 * Whether this device answers a focused text field with a soft keyboard
 * (#11742 round 6).
 *
 * The discriminator is input modality, not viewport width: a desktop window
 * narrowed under the phone breakpoint still has a physical keyboard, an iPad
 * (in the phone tier since #11742 round 8) pops one, and an iPad with a
 * trackpad keyboard
 * attached reports fine/hover and behaves like a laptop. Touch-primary
 * devices are the ones that report both no-hover and a coarse pointer.
 */
export const SOFT_KEYBOARD_QUERY = "(hover: none) and (pointer: coarse)";

export function hasSoftKeyboard(): boolean {
  return window.matchMedia(SOFT_KEYBOARD_QUERY).matches;
}
